import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SitemapPage from "@/pages/SitemapPage";

export const Route = createFileRoute("/sitemap")({
  head: () => buildRouteHead("/sitemap"),
  component: SitemapPage,
});

